
import { defineComponent, SetupContext, ref } from "vue";
import NativeClient from "@/client/native-client";
import { DETAIL_ITEM_TYPE, PANTRY_STRING, PLATE_DISPLAY_FORMAT, PLATE_STOCK_NOTIFICATION_TYPE, StockQuantityInfo, RegisterPantryPlatePlateInfo, PlateInfoData } from "@/types/pantry";
import DateUtil from "@/utils/date-util";

export default defineComponent({
  name: "PantryDetailDataValue",
  components: {
  },
  props: {
    itemType: {
      type: Number,
      default: -1
    },
    value: {
      type: String,
      defalut: ""
    },
    expirationDate: {
      type: String,
      defalut: ""
    },
    stockQuantity: {
      type: StockQuantityInfo,
      default: null
    },
    notificationStock: {
      type: RegisterPantryPlatePlateInfo,
      defalut: null
    },
    unit: {
      type: String,
      default: ""
    },
    plateData: {
      type: PlateInfoData,
      default: null
    }
  },
  setup(props, context: SetupContext) {
    const getNotificationDate = () => {
      let result = 0;
      NativeClient.sendDebugLog("PantryDetailDataValue getNotificationDate props.value=" + props.value + " props.expirationDate=" + props.expirationDate);
      if (props.value != null && props.expirationDate != null) {
        result = DateUtil.getDayCal(props.value, props.expirationDate);
      }
      NativeClient.sendDebugLog("PantryDetailDataValue getNotificationDate result=" + result);
      return result;
    };
    const isShowNotificationValue = () => {
      let result = false;
      if(props.itemType == DETAIL_ITEM_TYPE.NOTIFICATION && props.value != null) {
        const day = getNotificationDate();
        if (day > 0) {
          result = true;
        }
      }
      return result;
    };
    const isShowDate = () => {
      let result = false;
      if (props.itemType == DETAIL_ITEM_TYPE.PURCHASE_DATE || props.itemType == DETAIL_ITEM_TYPE.EXPIRATION_DATE) {
        result = true;
      } else if (props.itemType == DETAIL_ITEM_TYPE.NOTIFICATION && props.value != null) {
        const day = getNotificationDate();
        if (day <= 0) {
          result = true;
        }
      }
      return result;
    };
    const getDateValue = () => {
      return (props.value != null) ? DateUtil.formatYYYYMMDD(props.value) : PANTRY_STRING.PANTRY_NONE_SETTING;
    };
    const isShowStock = () => {
      return props.itemType == DETAIL_ITEM_TYPE.STOCK_QUANTITY;
    };
    const isShowStorage = () => {
      return props.itemType == DETAIL_ITEM_TYPE.STORAGE;
    };
    const isShowNotificationNone = () => {
      return props.itemType == DETAIL_ITEM_TYPE.NOTIFICATION && props.value == null;
    };
    const isShowStockNotificationValue = () => {
      return props.itemType == DETAIL_ITEM_TYPE.STOCK_NOTIFICATION
        && props.notificationStock != null
        && props.notificationStock.remaining != null
        && props.notificationStock.remaining.timing == PLATE_STOCK_NOTIFICATION_TYPE.STOCK_LOW;
    };
    const isShowStockNotificationTime = () => {
      return props.itemType == DETAIL_ITEM_TYPE.STOCK_NOTIFICATION
        && props.notificationStock != null
        && props.notificationStock.remaining != null
        && props.notificationStock.remaining.timing == PLATE_STOCK_NOTIFICATION_TYPE.EVERY_DAY;
    };
    const isShowStockNotificationNone = () => {
      return props.itemType == DETAIL_ITEM_TYPE.STOCK_NOTIFICATION;
    };
    const getStockValue = () => {
      return (props.stockQuantity != null) ? props.stockQuantity.value : 0;
    };
    const getStockUnit = () => {
      let result = "%";
      if (props.stockQuantity != null && props.stockQuantity.plate != null) {
        if (props.stockQuantity.plate.displayFormat == PLATE_DISPLAY_FORMAT.VALUE) {
          result = "個";
        }
      }
      return result;
    };
    const getStockNotificationValue = () => {
      const result = (props.notificationStock != null) ? props.notificationStock.thresholdCount : 0;
      return result;
    };
    const getStockNotificationTime = () => {
      const timeid = (props.notificationStock != null && props.notificationStock.remaining != null && props.notificationStock.remaining.time != null) ? props.notificationStock.remaining.time : 0;
      const result = "1日1回" + timeid + ":00";
      return result;
    };
    const getStockNotificationText = () => {
      let result = PANTRY_STRING.PANTRY_NONE_NOTIFICATION;
      if (props.notificationStock != null && props.notificationStock.remaining != null && props.notificationStock.remaining.timing == PLATE_STOCK_NOTIFICATION_TYPE.STOCK_CHANGE) {
        result = PANTRY_STRING.PANTRY_PLATE_STOCK_CHANGE;
      }
      return result;
    };
    const getStockNotificationUnit = () => {
      let result = "個";
      if (props.plateData != null && props.plateData.data != null && props.plateData.data.unit != null) {
        if (props.plateData.data.unit.displayFormat == PLATE_DISPLAY_FORMAT.GAUGE) {
          result = "%";
        }
      }
      return result;
    };
    return {
      isShowDate,
      isShowStock,
      isShowStorage,
      isShowNotificationValue,
      isShowNotificationNone,
      isShowStockNotificationTime,
      isShowStockNotificationValue,
      isShowStockNotificationNone,
      getStockValue,
      getStockUnit,
      getDateValue,
      getNotificationDate,
      getStockNotificationTime,
      getStockNotificationValue,
      getStockNotificationText,
      getStockNotificationUnit,
      PANTRY_STRING
    };
  }
});
